const EXTENSION_PATH_PREFIXES = ['/extension', '/extension-local'] as const;

/**
 * Whether the current page is rendered inside the Chrome extension sidepanel
 * (or the local development preview that embeds it). Matches `/extension` and
 * `/extension-local` but not other routes sharing the prefix (e.g.
 * `/extension-review`).
 */
export function isExtensionContext(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    const { pathname } = window.location;
    return EXTENSION_PATH_PREFIXES.some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    );
}

type ExtensionFrameEnvironment = {
    readonly frameName: string;
    readonly self: Window;
    readonly top: Window | null;
};

export const PHOEBE_EXTENSION_FRAME_NAME = 'phoebe-extension-sidepanel';

/**
 * Whether the full Phoebe app is embedded by the extension side panel or its
 * same-origin local preview.
 */
export function isEmbeddedExtensionFrame(
    environment: ExtensionFrameEnvironment | undefined = typeof window ===
    'undefined'
        ? undefined
        : {
              frameName: window.name,
              self: window.self,
              top: window.top,
          },
): boolean {
    return (
        environment !== undefined &&
        environment.self !== environment.top &&
        environment.frameName === PHOEBE_EXTENSION_FRAME_NAME
    );
}
